import { MutationTree } from 'vuex'

import { ReceiptState } from '@/types/store'
import { IReceipt, ISummaries, ReceiptType } from '@/types/receipt'

export const mutations: MutationTree<ReceiptState> = {
  receiptsLoadStart(state) {
    state.isReceiptsLoading = true
  },
  receiptsLoaded(state, payload: [IReceipt[], number]) {
    state.receipts = payload[0]
    state.total = payload[1]
    state.isReceiptsLoading = false
  },
  setReceipt(state, receipt: IReceipt) {
    state.receipt = receipt
  },
  setReceiptById(state, payload: number) {
    const nextReceipt = state.receipts.find(receipt => receipt.id === payload)
    state.receipt = nextReceipt || null
  },
  setMasterSearch(state, payload: ReceiptState['masterSearchItem']) {
    state.masterSearchItem = payload
  },
  updateMasterItem(state, payload: ReceiptState['masterSearchItem']) {
    if (state.receipt === null) return
    state.receipt.items[payload.index] = payload.item
  },
  updateReceipt(state, payload: ReceiptState['receipt']) {
    if (!payload) return
    if (!state.receipts) return
    const receiptIndex = state.receipts.findIndex(
      receipt => receipt.id === payload.id,
    )
    state.receipts.splice(receiptIndex, 1, payload)
  },
  setIsSummariesLoading(state, isSummariesLoading: boolean) {
    state.isSummariesLoading = isSummariesLoading
  },
  summariesLoaded(state, summaries: ISummaries) {
    state.summaries = summaries
  },
  setReceiptType(state, receiptType: ReceiptType): void {
    state.receiptType = receiptType
  },
}
